export default __webpack_public_path__ + "static/media/up-here-next.06a71d5c.webp";